import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../client/components/Navbar";
import Footer from "../client/components/Footer";
import Header from "../client/components/Header";
import HeadFilter from "../client/components/HeadFilter";

// Pages sans header / navbar / footer
const AUTH_ROUTES = ["/login", "/register"];

export default function ClientLayout() {
  const location = useLocation();
  const isAuthPage = AUTH_ROUTES.includes(location.pathname);

  // Page d'authentification : isolée, sans chrome du site
  if (isAuthPage) {
    return (
      <main style={{ minHeight: "100vh" }}>
        <Outlet />
      </main>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header />
      <Navbar />

      <main style={{ flex: 1, display: "inline-block" }}>
        {location.pathname.startsWith("/category") && (
          <aside style={{ background: "#ffffff", padding: "2rem", margin: "0.5rem 0rem" }}>
            <HeadFilter />
          </aside>
        )}
        <section style={{ flex: 1 }}>
          <Outlet />
        </section>
      </main>
      <Footer />
    </div>
  );
}
